<script>
import Static from "@/views/Static.vue";

export default {
    name: "Privacy",
    extends: Static
};
</script>
